import { t, UUID, DateTimeISO, Status } from '../common.ts';

export const SettingScope = t.Union([
  t.Literal('system'),
  t.Literal('site'),
  t.Literal('wallet'),
  t.Literal('finance'),
  t.Literal('promo'),
  t.Literal('bet'),
  t.Literal('security'),
  t.Literal('notify'),
]);

export const SettingView = t.Object(
  {
    key: t.String(),
    scope: SettingScope,
    value: t.Unknown(),
    description: t.Union([t.String(), t.Null()]),
    updatedAt: DateTimeISO,
    updatedBy: t.Union([UUID, t.Null()]),
  },
  { $id: 'SettingView' },
);

export const UpdateSettingRequest = t.Object(
  {
    value: t.Unknown(),
    description: t.Optional(t.String({ maxLength: 500 })),
  },
  { $id: 'UpdateSettingRequest' },
);

export const FeatureFlagView = t.Object(
  {
    key: t.String(),
    enabled: t.Boolean(),
    rollout: t.Integer({ minimum: 0, maximum: 100 }),
    description: t.Union([t.String(), t.Null()]),
    updatedAt: DateTimeISO,
  },
  { $id: 'FeatureFlagView' },
);

const IpPolicyBaseShape = {
  ipCidr: t.String(),
  action: t.Union([t.Literal('allow'), t.Literal('deny')]),
  scope: t.Union([t.Literal('backoffice'), t.Literal('client'), t.Literal('partner'), t.Literal('all')]),
  note: t.Union([t.String(), t.Null()]),
  status: Status,
} as const;

export const IpPolicyView = t.Object(
  {
    id: UUID,
    ...IpPolicyBaseShape,
    createdAt: DateTimeISO,
  },
  { $id: 'IpPolicyView' },
);

export const CreateIpPolicyRequest = t.Object(
  { ...IpPolicyBaseShape },
  { $id: 'CreateIpPolicyRequest' },
);

export const SiteBrandingView = t.Object(
  {
    siteId: UUID,
    siteCode: t.String(),
    displayName: t.String(),
    logoUrl: t.Union([t.String(), t.Null()]),
    faviconUrl: t.Union([t.String(), t.Null()]),
    primaryColor: t.Union([t.String(), t.Null()]),
    secondaryColor: t.Union([t.String(), t.Null()]),
    domains: t.Array(t.String()),
    updatedAt: DateTimeISO,
  },
  { $id: 'SiteBrandingView' },
);

export const MaintenanceWindowView = t.Object(
  {
    id: UUID,
    scope: t.Union([
      t.Literal('all'),
      t.Literal('client'),
      t.Literal('backoffice'),
      t.Literal('partner'),
      t.Literal('game_provider'),
    ]),
    targetId: t.Union([UUID, t.Null()]),
    startsAt: DateTimeISO,
    endsAt: DateTimeISO,
    message: t.String(),
    status: t.Union([t.Literal('scheduled'), t.Literal('active'), t.Literal('done'), t.Literal('cancelled')]),
  },
  { $id: 'MaintenanceWindowView' },
);
